import { useCallback, useState } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { postCaseComment } from '@/api/urgent-cases';
import { useUserProfile } from '@/states/user-profile';
import { toast_success } from '@/libs/toast-wrappers';
import { devlog } from '@/libs/dev-logs';

export function usePostCaseComment() {
  const [isLoading, setIsLoading] = useState(false);
  const profile = useUserProfile(useShallow((s) => s.profile));

  const submitComment = useCallback(
    async (caseId: string, content: string, isInternal?: boolean) => {
      setIsLoading(true);
      try {
        const response = await postCaseComment(caseId, { content, is_internal: isInternal });
        toast_success('Comment posted successfully');
        return response;
      } catch (error) {
        devlog('Error posting case comment', error);
        throw error;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  return { isLoading, submitComment, userEmail: profile?.email };
}
